export default __webpack_public_path__ + "static/media/people-crying.074bb3c2.jpg";